import { getEnumMemberName } from 'utils/helpers'

export const AssetClass = {
  profile: 'profile',
  pixel: 'pixel',
  ad_account: 'ad_account',
}

export const Platform = {
  facebook: 'facebook',
  instagram: 'instagram',
}

export function parsePartnerIntegrations(data) {
  if (!Array.isArray(data)) return []

  return data
    .map((integration) => {
      if (!integration.asset_class || !integration.platform) return null
      const assetClassParts = integration.asset_class.split('.')
      const platformParts = integration.platform.split('.')
      if (
        !integration.asset_label &&
        [AssetClass.pixel, AssetClass.ad_account].some((x) => integration.asset_class.includes(x))
      ) {
        integration.asset_label = 'Facebook'
      }

      if (integration.connected_assets) {
        integration.connected_assets = integration.connected_assets.map((connectedAsset) => ({
          ...connectedAsset,
          platform: getEnumMemberName(connectedAsset.platform),
          asset_class: getEnumMemberName(connectedAsset.asset_class),
        }))
      }
      if (integration.asset_users) {
        integration.asset_users = integration.asset_users.map((user) => ({
          ...user,
          token_type: getEnumMemberName(user.token_type),
        }))
      }

      return {
        ...integration,
        platform: platformParts[platformParts.length - 1],
        asset_class: assetClassParts[assetClassParts.length - 1],
        asset_label: integration.asset_label ?? '',
      }
    })
    .filter(Boolean)
}
